import React from "react";
import { all, takeEvery, put, call } from "redux-saga/effects";
import { toast } from "react-toastify";
import { Toast } from "../../utils/helper";
import {
  GENERATE_QUESTION,
  POST_QUESTION,
  GET_QUESTION_LIBRARY,
} from "../action/types";
import {
  generateQuestionSuccess,
  generateQuestionFailure,
  createOrUpdateQuestionSuccess,
  createOrUpdateQuestionFailure,
  getQuestionLibrarySuccess,
  getQuestionLibraryFailure,
} from "../action";
import POSITION from "../../utils/api/candidate";
function* postQuestionRequest(action) {
  try {
    const res = yield POSITION.post(
      `incscreen/positions/createQuestion`,
      action?.payload?.finalQuestionForm,
    );
    if (res.status === 201) {
      yield put(createOrUpdateQuestionSuccess(res.data.result));
      yield call(action.payload.callback(res.data.result));
    }
  } catch (e) {
    yield put(createOrUpdateQuestionFailure());
    const errorMessage = e?.response?.data?.message;
    if (errorMessage) {
      toast.error(<Toast msg={errorMessage} />, {
        autoClose: 5000,
        toastId: errorMessage,
      });
    }
  }
}
function* generateQuestionRequest(action) {
  try {
    const res = yield POSITION.get(
      `incscreen/positions/generateQuestionFields/${action.payload.position}`,
    );
    if (res.status === 201 || res.status === 200) {
      yield put(generateQuestionSuccess(res.data));
      yield call(action.payload.callback(res.data?.result));
    }
  } catch (e) {
    yield put(generateQuestionFailure());
    yield e?.response?.data?.message &&
      e?.response?.data?.message !==
        "Your session has been expired, please login again!" &&
      toast.error(<Toast msg={e?.response?.data?.message} />, {
        autoClose: 5000,
        toastId: e?.response?.data?.message,
      });
  }
}
function* getQuestionLibraryRequest() {
  try {
    const res = yield POSITION.get("incscreen/positions/questionLibrary");
    if (res.status === 200 || res.status === 201) {
      yield put(getQuestionLibrarySuccess(res.data?.result));
    }
  } catch (e) {
    yield put(getQuestionLibraryFailure());
  }
}
export function* watchGenerateQuestionAPI() {
  yield takeEvery(GENERATE_QUESTION, generateQuestionRequest);
}
export function* watchPostQuestionAPI() {
  yield takeEvery(POST_QUESTION, postQuestionRequest);
}
export function* watchGetQuestionLibrary() {
  yield takeEvery(GET_QUESTION_LIBRARY, getQuestionLibraryRequest);
}
export default function* rootSaga() {
  yield all([
    watchGenerateQuestionAPI(),
    watchPostQuestionAPI(),
    watchGetQuestionLibrary(),
  ]);
}
